module.exports = "../../../../platform/assets/pageMainIcon/yewushezhilei1.svg";